import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'en',
    detection: {
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['cookie'],
      cookieName: 'aba_lang',
      cookieMinutes: 525600,
    },
    interpolation: {
      escapeValue: false,
    },
  });

// <html lang> follows the UI language on every page (screen readers, browser
// translation prompts). This is the ONE place that sets it from the language
// switch; usePageSeo (lib/seo.js) only overrides it for pages with their own
// language (e.g. the /es home) and restores it through currentHtmlLang().
/** "es" for any Spanish locale, otherwise "en". */
export function htmlLangFor(lng) {
  return String(lng || "en").toLowerCase().startsWith("es") ? "es" : "en";
}

/** The <html lang> value for the current UI language. */
export function currentHtmlLang() {
  return htmlLangFor(i18n.language);
}

function applyHtmlLang() {
  if (typeof document === "undefined") return;
  document.documentElement.lang = currentHtmlLang();
}

i18n.on("languageChanged", applyHtmlLang);
applyHtmlLang();

export default i18n;
